'use client';

import styled from '@emotion/styled';
import { Css, Responsive, UnstyledUl } from '../../../ui';
import { theme } from '../../../styles/theme';
import { Section } from '../../content-sections/ui/components/Section';

export const WidgetsSection = styled(Section)`
	padding-top: ${Css.pxToRem(32)};
`;

export const WidgetsContainer = styled(UnstyledUl)<{
	columns?: number;
}>`
	position: relative;
	display: grid;
	grid-column-gap: ${theme.grid?.gutter?.vertical?.default};
	grid-row-gap: ${theme.grid?.gutter?.horizontal?.default};
	padding: 0;
	margin: 0;
	grid-template-columns: ${({ columns }) =>
		columns ? `repeat(${columns}, 1fr)` : `repeat(3, 1fr)`};

	li {
		margin-top: 0;
		min-width: 0;
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tabletXL')}) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media (${Responsive.getMediaQueryForBreakpoint('tablet')}) {
		grid-template-columns: 1fr;
		grid-row-gap: ${theme.grid?.gutter?.horizontal?.mobile};
	}
`;
